<template>
  <div class="as-content-page">
    <filter-tags
      :countries="countries"
      :tags="tags"
      :leagues="leagues"
      :sortBy="sortBy"
      :filter="filter"
      @changeLeague="(newVal) => changeLeague(newVal)"
      @changeCountry="(newVal: ICountry) => changeCountry(newVal)"
    />
  </div>

  <div v-if="isLoading" class="as-py-12">
    <StandingListSkeleton />
  </div>
  <StandingList
    v-else
    :standing="standing"
    :league="filter.league"
    :isPopup="false"
    @changeSeason="setSeason"
    class="as-text-white"
  />
</template>

<script lang="ts">
import { defineComponent, toRaw } from "vue";
import { competitionFeatured, matchStanding } from "~src/services/SpapiService";
import StandingListSkeleton from "~src/components/skeleton/standing/StandingListSkeleton.vue";
import FilterTags from "~src/components/FilterTags.vue";
import StandingList from "~src/components/standings/StandingList.vue";
import type { ILeague, ICountry } from "~src/interfaces";

export default defineComponent({
  name: "StandingHome",
  components: {
    StandingListSkeleton,
    FilterTags,
    StandingList,
  },
  props: {
    seasonId: {
      type: String,
    },
  },
  data() {
    return {
      tags: [],
      leagues: [] as Array<ILeague>,
      all_leagues: [] as Array<ILeague>,
      countries: [] as Array<ICountry>,
      isLoading: false,
      sortBy: "league",
      standing: null,
      filter: {
        tag: null,
        league: {} as ILeague,
        country: {} as ICountry,
      },
    };
  },
  async created() {
    this.isLoading = true;
    const rs = await competitionFeatured();
    this.all_leagues = rs.data.data;

    const uniqueCountries: ICountry[] = Array.from(
      new Map(
        rs.data.data
          .filter((item: ILeague) => item?.country)
          .map((item: ILeague) => [item?.country?.id, item?.country])
      ).values()
    ) as ICountry[];

    const country = null;
    this.countries = uniqueCountries;

    await this.setLeague(country);
    const rsS = await matchStanding(this.filter.league.cur_season_id);
    this.standing = rsS.data.data;
    this.isLoading = false;
  },
  methods: {
    async changeLeague(newVal: ILeague) {
      this.isLoading = true;
      this.filter.league = newVal;
      const rsS = await matchStanding(newVal.cur_season_id);
      this.standing = rsS.data.data;
      this.isLoading = false;
    },
    async changeCountry(country: ICountry) {
      this.isLoading = true;
      await this.setLeague(country);

      const rsS = await matchStanding(this.filter.league.cur_season_id);
      this.standing = rsS.data.data;
      this.isLoading = false;
    },
    async setLeague(country: ICountry | null) {
      this.filter.country = country as ICountry;
      if (country) {
        this.leagues = this.all_leagues.filter((item) => {
          return item.country_id === country.id;
        });
      } else {
        this.leagues = this.all_leagues;
      }

      if (this.seasonId) {
        const league = this.leagues.find(
          (item: ILeague) => item.cur_season_id === this.seasonId
        );
        if (league) {
          this.filter.league = league;
        } else {
          this.filter.league = this.leagues[0];
        }
      } else {
        this.filter.league = this.leagues[0];
      }
    },
    async setSeason(id: string) {
      this.filter.league.cur_season_id = id;
      this.isLoading = true;
      const rsS = await matchStanding(this.filter.league.cur_season_id);
      this.standing = rsS.data.data;
      this.isLoading = false;
    },
  },
});
</script>

<style scoped></style>
